<template>
  <div class="sidebar sidebar-irish-date" >
    <div class="user" style="z-index: 3">
      <div class="photo photo-full text-center mb-3">
        <img
          src="@/assets/images/my-irish-date/mid-icon-green.png"
          id="adminNavLogoImg"
        /><img
          src="@/assets/images/my-irish-date/logo-text.png"
          class="d-block m-auto w-75"
        />
      </div>
    </div>
    <div class="sidebar-wrapper">
      <ul class="nav">
        <li class="nav-item">
           <router-link to="/my_irish_date/dashboard" class="nav-link d-flex"> <img
              class="my-nav-icon my-nav-icon-grey"
              src="@/assets/images/my-irish-date/dashboard-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-top"
              src="@/assets/images/my-irish-date/dashboard-icon-active.png"
              alt=""
            />
            <p>Dashboard</p></router-link> 
          
        </li>
        <li class="nav-item">
           <router-link to="/my_irish_date/calendar" class="nav-link d-flex"> <img
              class="my-nav-icon my-nav-icon-grey"
              src="@/assets/images/my-irish-date/calendar-icon.png"
              alt="" style="width: 25px; height:25px"
            />
            <img
              class="my-nav-icon my-nav-icon-top"
              src="@/assets/images/my-irish-date/calendar-icon-active.png"
              alt="" style="width: 25px; height:25px"
            />
            <p>Calendar</p></router-link>
          
        </li>
        <li class="nav-item">
          <router-link to="/my_irish_date/manage_app" class="nav-link d-flex"> 
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-grey"
              src="@/assets/images/my-irish-date/manage-app-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-top"
              src="@/assets/images/my-irish-date/manage-app-icon-active.png"
              alt=""
            />
            <p>Manage App</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/my_irish_date/events" class="nav-link d-flex"> 
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-grey"
              src="@/assets/images/my-irish-date/events-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-top"
              src="@/assets/images/my-irish-date/events-icon-active.png"
              alt=""
            />
            <p>Events</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/my_irish_date/users" class="nav-link d-flex"> 
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-grey"
              src="@/assets/images/my-irish-date/users-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-top"
              src="@/assets/images/my-irish-date/users-icon-active.png"
              alt=""
            />
            <p>Users</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/my_irish_date/video_library" class="nav-link d-flex"> 
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-grey"
              src="@/assets/images/my-irish-date/video-library-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-top"
              src="@/assets/images/my-irish-date/video-library-icon-active.png"
              alt=""
            />
            <p>Video Library</p>
          </router-link>
        </li>        
        <li class="nav-item">
          <router-link to="/my_irish_date/music_library/spotify_playlists" class="nav-link d-flex"> 
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-grey"
              src="@/assets/images/my-irish-date/spotify-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-top"
              src="@/assets/images/my-irish-date/spotify-icon-active.png"
              alt=""
            />
            <p>Spotify Playlists</p>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/my_irish_date/settings" class="nav-link d-flex"> 
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-grey"
              src="@/assets/images/my-irish-date/settings-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-long my-nav-icon-top"
              src="@/assets/images/my-irish-date/settings-icon-active.png"
              alt=""
            />
            <p>Settings</p>
          </router-link>
        </li> 
        <li class="nav-item">
          <a class="nav-link d-flex" href="" @click="logout">
            <img
              class="my-nav-icon my-nav-icon-grey"
              src="@/assets/images/my-irish-date/logout-icon.png"
              alt=""
            />
            <img
              class="my-nav-icon my-nav-icon-top"
              src="@/assets/images/my-irish-date/logout-icon-active.png"
              alt=""
            />
            <p>Logout</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarMyIrishSDate",
  data() {
    return {};
  },
  methods: { logout() {
      console.log("logoutt ssstt")
      //  console.log(this.$children)
      // this.$confirm({
      //   title: 'Are you sure?',
      //   message: 'Are you sure you want to logout?',
      //   button: {
      //     yes: 'Yes',
      //     no: 'Cancel'
      //   },
      //   callback: confirm => {
      //     if (confirm) {
      localStorage.removeItem("user");
      localStorage.removeItem("customer");
      //  App.isLogin = false;
      this.$router.go({ name: 'MyIrishDateLogin' })
      console.log(localStorage)
      //     }
      //   }
      // })
    },},
}
</script>


// WEBPACK FOOTER //
// src/components/partials/admin_sidebar_mid.vue